import { render, staticRenderFns } from "./get-patient-benefits-action-input.vue?vue&type=template&id=0aba88a1&scoped=true"
import script from "./get-patient-benefits-action-input.vue?vue&type=script&lang=js"
export * from "./get-patient-benefits-action-input.vue?vue&type=script&lang=js"
import style0 from "./get-patient-benefits-action-input.vue?vue&type=style&index=0&id=0aba88a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba88a1",
  null
  
)

export default component.exports